import { Component, input } from '@angular/core';
import { AiAction, FieldChangesAction } from '../../../services/ai-panel/ai-action.types';
import { WgAiActionFieldChangesComponent } from './wg-ai-action-field-changes.component';

@Component({
  selector: 'app-wg-ai-action-card',
  standalone: true,
  imports: [WgAiActionFieldChangesComponent],
  template: `
    @if (isFieldChanges(action())) {
      <app-wg-ai-action-field-changes [action]="asFieldChanges(action())" />
    } @else {
      <div class="rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-3 py-2.5 mt-2">
        <div class="flex items-center gap-2">
          <span class="material-symbols-outlined" style="font-size:16px;color:#94a3b8">widgets</span>
          <span class="text-xs font-semibold text-slate-600 dark:text-slate-300">{{ action().title }}</span>
          <span class="text-[10px] text-slate-400 ml-auto italic">{{ action().type }}</span>
        </div>
        @if (action().description) {
          <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-1">{{ action().description }}</p>
        }
        <p class="text-[10px] text-slate-400 mt-1 italic">Kmalu na voljo</p>
      </div>
    }
  `
})
export class WgAiActionCardComponent {
  action = input.required<AiAction>();

  isFieldChanges(action: AiAction): action is FieldChangesAction {
    return action.type === 'field-changes';
  }

  asFieldChanges(action: AiAction): FieldChangesAction {
    return action as FieldChangesAction;
  }
}
